import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { from, map } from 'rxjs';

/**
 * Loads locale JSON via a dynamic `import()` so Angular's build bundles each
 * translation file as a content-hashed chunk. The hash changes every release,
 * which busts the browser cache on deploy while still allowing caching within a
 * release. The static prefix/suffix let esbuild eagerly bundle every locale in
 * `public/assets/i18n/`, so all languages are included in the build.
 */
@Injectable()
export class LazyTranslateLoader implements TranslateLoader {
  public getTranslation(lang: string): ReturnType<TranslateLoader['getTranslation']> {
    return from(import(`../../../../../../public/assets/i18n/${lang}.json`)).pipe(map((module) => module.default));
  }
}
